<nav class="auth-legal-footer" aria-label="Rechtliches">
  <a [href]="imprintUrl" target="_blank" rel="noopener" class="link-text">
    {{ "LEGAL_IMPRINT" | translate }}
  </a>
  <span class="sep" aria-hidden="true">·</span>
  <a [href]="privacyUrl" target="_blank" rel="noopener" class="link-text">
    {{ "GDPR_PRIVACY_POLICY" | translate }}
  </a>
  <span class="sep" aria-hidden="true">·</span>
  <a [href]="termsUrl" target="_blank" rel="noopener" class="link-text">
    {{ "GDPR_TERMS_OF_SERVICE" | translate }}
  </a>
</nav>
